import { get, isFunction } from "lodash";
import { useRouter } from "next/router";
import Link from "next/link";
import { getCategoryLinkAttributesFromRouter } from "grandus-lib/hooks/useFilter";

const CategoryOrderingElement = ({
  text = "",
  newOrdering = "",
  handleLinkAttributes = null,
}) => {
  const router = useRouter();
  let attributes = null;
  if (isFunction(handleLinkAttributes)) {
    attributes = handleLinkAttributes(router, newOrdering);
  } else {
    attributes = getCategoryLinkAttributesFromRouter(router, {
      dataToChange: { orderBy: newOrdering },
      toDelete: ["category", "parameters", "page"],
    });
  }
  const isActive =
    get(
      router,
      "query.orderBy",
      process.env.NEXT_PUBLIC_PRODUCT_DEFAULT_ORDERING
    ) == newOrdering;
  return (
    <Link {...attributes} scroll={false}>
      <a
        className="button secondary"
        style={{ textDecoration: isActive ? "underline" : "none" }}
      >
        {text}
      </a>
    </Link>
  );
};

const CategoryOrdering = ({ handleLinkAttributes, styles, totalCount }) => {
  return (
    <>
      <nav className={styles.filters}>
        <div className={styles.items}>
          <p>
            <strong>Zoradiť podľa:</strong>
          </p>

          <CategoryOrderingElement
            text={"Najnovšie"}
            newOrdering={"time-desc"}
            handleLinkAttributes={handleLinkAttributes}
          />
          <CategoryOrderingElement
            text={"Najlacnejšie"}
            newOrdering={"price-asc"}
            handleLinkAttributes={handleLinkAttributes}
          />
          <CategoryOrderingElement
            text={"Najdrahšie"}
            newOrdering={"price-desc"}
            handleLinkAttributes={handleLinkAttributes}
          />
        </div>
        <p>počet produktov: {totalCount ? totalCount : 1}</p>
      </nav>
    </>
  );
};

export default CategoryOrdering;
